import { Button, Icon } from "@gravity-ui/uikit";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  slideButtonAnimation,
  SlideIdType,
  slidesButton,
} from "src/widgets/WelcomeModal/constants";

interface SlideButtonProps {
  cardId: SlideIdType;
  activeIndex: number;
}

export const SlideButton = ({ cardId, activeIndex }: SlideButtonProps) => {
  const { title, href, blank, onClick, icon } = slidesButton[cardId];

  const renderButton = () => (
    <Button
      view="outlined-action"
      size="l"
      style={{ width: "fit-content" }}
      onClick={onClick}
    >
      {title}
      <Icon data={icon} size={20} />
    </Button>
  );

  return (
    <motion.div {...slideButtonAnimation} key={`${cardId}.${activeIndex}`}>
      {href ? (
        <Link to={href} target={blank ? "_blank" : "_self"} onClick={onClick}>
          {renderButton()}
        </Link>
      ) : (
        renderButton()
      )}
    </motion.div>
  );
};
